<div class="my-2">
  <app-warning-container warningTitle="Open Hours Warning" *ngIf="showOpenHoursWarning">
    <span> The booking window may fall outside of the site open hours. </span>
  </app-warning-container>
</div>

<div class="my-2">
  <app-warning-container warningTitle="Standard Hours Warning" *ngIf="showStandardHoursWarning">
    <span> The booking window falls outside of standard business hours (9am to 5pm). </span>
  </app-warning-container>
</div>
